import { render, staticRenderFns } from "./informationModal.vue?vue&type=template&id=44f08603&scoped=true&"
import script from "./informationModal.vue?vue&type=script&lang=ts&"
export * from "./informationModal.vue?vue&type=script&lang=ts&"
import style0 from "./informationModal.vue?vue&type=style&index=0&id=44f08603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f08603",
  null
  
)

export default component.exports